import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerUserRoleUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.userRoles.update),
			switchMap((action) =>
				this.consumerAdminService.updateUserRoles(action.username, action.roles).pipe(
					map(() => ConsumerAdminActions.userRoles.updateSuccess()),
					catchError((error) =>
						of(ConsumerAdminActions.userRoles.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
